export default __webpack_public_path__ + "static/media/pastagem.a80c6b0f.svg";